module.exports = __webpack_public_path__ + "static/media/71p5GSQ-BVL._AC_SL1500_.dbd0c1ed.jpg";